<template>
  <div class="sla-filters-block">
    <div class="info-row">
      <button
        type="button"
        class="info-btn"
        title="Info"
        @click="$emit('info')"
      >
        <i class="bi bi-info-circle" />
      </button>
    </div>
    <div class="sla-mgmt-filters">
      <div class="sla-filters-row">
        <ReportFilterField label="Brand">
          <ReportTagMultiSelect
            :modelValue="modelValue.brands"
            :options="brands"
            placeholder="(All)"
            @update:modelValue="patch({ brands: $event })"
          />
        </ReportFilterField>
        <ReportFilterField label="Location">
          <ReportTagMultiSelect
            :modelValue="modelValue.locations"
            :options="locations"
            placeholder="(All)"
            @update:modelValue="patch({ locations: $event })"
          />
        </ReportFilterField>
        <ReportFilterField label="End Date">
          <ReportConstrainedDatePicker
            :modelValue="modelValue.endDate"
            :minDate="minEndDate"
            :maxDate="maxEndDate"
            :allowedWeekdays="[6]"
            @update:modelValue="patch({ endDate: $event })"
          />
        </ReportFilterField>
        <ReportFilterField label="Base Date">
          <select
            class="sla-select"
            :value="modelValue.baseDate"
            @change="patch({ baseDate: $event.target.value })"
          >
            <option
              v-for="o in baseDates"
              :key="o"
              :value="o"
            >
              {{ o }}
            </option>
          </select>
        </ReportFilterField>
        <ReportFilterField label="Periodicity">
          <select
            class="sla-select"
            :value="modelValue.periodicity"
            @change="patch({ periodicity: $event.target.value })"
          >
            <option
              v-for="o in periodicities"
              :key="o"
              :value="o"
            >
              {{ o }}
            </option>
          </select>
        </ReportFilterField>
        <ReportFilterField label="Metric">
          <select
            class="sla-select"
            :value="modelValue.metric"
            @change="patch({ metric: $event.target.value })"
          >
            <option
              v-for="o in metrics"
              :key="o"
              :value="o"
            >
              {{ o }}
            </option>
          </select>
        </ReportFilterField>
        <ReportFilterField
          class="sla-filter-col--radio"
          label="LTM Type"
        >
          <div class="sla-radio-group">
            <label
              v-for="t in ltmTypes"
              :key="t"
              class="sla-radio"
            >
              <input
                type="radio"
                name="sla-ltm-type"
                :value="t"
                :checked="modelValue.slaType === t"
                @change="patch({ slaType: t })"
              />
              <span>{{ t }}</span>
            </label>
          </div>
        </ReportFilterField>
      </div>
    </div>
  </div>
</template>

<script>
import {
  BASE_DATES,
  LTM_TYPES,
  METRICS,
  PERIODICITIES,
} from './heatmapUtils';
import ReportTagMultiSelect from '@/components/Reports/ReportTagMultiSelect.vue';
import ReportConstrainedDatePicker from '@/components/Reports/ReportConstrainedDatePicker.vue';
import ReportFilterField from '@/components/Reports/ReportFilterField.vue';

export default {
  name: 'SlaFilters',
  components: {
    ReportTagMultiSelect,
    ReportConstrainedDatePicker,
    ReportFilterField,
  },
  props: {
    modelValue: {
      type: Object,
      required: true,
    },
    brands: {
      type: Array,
      default() {
        return [];
      },
    },
    locations: {
      type: Array,
      default() {
        return [];
      },
    },
    minEndDate: {
      type: String,
      default: '',
    },
    maxEndDate: {
      type: String,
      default: '',
    },
  },
  emits: [ 'update:modelValue', 'info' ],
  data() {
    return {
      metrics: METRICS,
      periodicities: PERIODICITIES,
      baseDates: BASE_DATES,
      ltmTypes: LTM_TYPES,
    };
  },
  methods: {
    patch(partial) {
      this.$emit('update:modelValue', {
        ...this.modelValue,
        ...partial,
      });
    },
  },
};
</script>
